import { render, staticRenderFns } from "./chat-window-empty-state.vue?vue&type=template&id=26f3ba4a&scoped=true&"
import script from "./chat-window-empty-state.vue?vue&type=script&lang=js&"
export * from "./chat-window-empty-state.vue?vue&type=script&lang=js&"
import style0 from "./chat-window-empty-state.vue?vue&type=style&index=0&id=26f3ba4a&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26f3ba4a",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VDivider,VMenu})


/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('26f3ba4a')) {
      api.createRecord('26f3ba4a', component.options)
    } else {
      api.reload('26f3ba4a', component.options)
    }
    module.hot.accept("./chat-window-empty-state.vue?vue&type=template&id=26f3ba4a&scoped=true&", function () {
      api.rerender('26f3ba4a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/atendimento/components/chat-window-empty-state/chat-window-empty-state.vue"
export default component.exports